import TimeSlotSelectItem from './TimeSlotSelectItem'

export default TimeSlotSelectItem
